import { permissionsList, userPermissionsList } from "./constants";

export function getById(input: string | any[], id: string | number, idParam = 'id') {
    var i = 0,
        len = input.length;
    for (; i < len; i++) {
        if (+input[i][idParam] == +id) {
            return input[i];
        }
    }
    return null;
}

export function hasPermission(key: string, permissionIds?: string): boolean {
    if (!permissionIds) return true;
    // Get the property name associated with the given key
    const property = permissionsList[key as keyof typeof permissionsList];

    // If the property does not exist in permissionsList, return false
    if (!property) return false;

    // Split the permission IDs string into an array for easy lookup
    const permissionIdArray = permissionIds.split(',');

    // Find a matching item in userPermissionsList
    return userPermissionsList.some(item =>
        item.property === property && permissionIdArray.includes(item.id)
    );
}